var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer"},[_vm._v("\n           ©"+_vm._s(new Date().getFullYear())+" Advenue. All rights reserved. Build:"+_vm._s('')+" 04122020-1\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }